import {observable, action} from 'mobx';
import _ from 'lodash';

const initialQuestion = {
  question: '',
  key_learnings: '',
  explanation: '',
  options: [{
    body: '',
    correct: '',
  }],
  theme_ids: [],
};

class McqQuestionsStore {

  @observable questions = [];
  @observable question = initialQuestion;
  @observable errors = {};

  @action
  setQuestions = data => {
    this.questions = data;
  };

  @action
  setQuestion = data => {
    this.question = data;
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  getErrorToQuestions = i => {
    if(!this.errors)
      return {};
    return this.errors;
  };

  @action
  clearQuestions = () => {
    this.questions = [];
  };

  @action
  clearQuestion = () => {
    this.question = initialQuestion;
  };

  @action
  handleChangeQuestion = data => {
    this.question = data;
  }

  @action
  addQuestionOption = (data) => {
    this.question = data;
  };
}

export default new McqQuestionsStore();



// WEBPACK FOOTER //
// ./src/stores/McqQuestionsStore.js